import { render, staticRenderFns } from "./CpuModelAddOrEditModal.vue?vue&type=template&id=51ecbc5a&scoped=true"
import script from "./CpuModelAddOrEditModal.vue?vue&type=script&lang=js"
export * from "./CpuModelAddOrEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecbc5a",
  null
  
)

export default component.exports